import {useQuery} from 'services/apollo';
import {EzPage, EzHeading} from '@ezcater/recipe';
import gql from 'graphql-tag';
import {useTranslation} from 'react-i18next';
import {
  type CompletedDeliveriesAssignmentsQuery,
  type CompletedDeliveriesAssignmentsQueryVariables,
  DriverAssignmentState,
} from 'services/graphql/types';
import DeliveryCardContainer from 'components/DeliveryCardContainer';
import {addDays, startOfToday} from 'date-fns';
import Layout from '../Layout';

export const AssignmentsQuery = gql(/* GraphQL */ `
  query CompletedDeliveriesAssignmentsQuery(
    $eventAtRange: TimeRangeInput
    $state: DriverAssignmentState
  ) {
    me {
      driverAccount {
        assignments(eventAtRange: $eventAtRange, state: $state) {
          nodes {
            dropoffAddress {
              city
              id
              state
              street1
              street2
              zip
            }
            eventAt
            formattedOrderNumber
            id
            pickupAddress {
              id
              timeZoneIdentifier
            }
            status
          }
        }
        id
      }
    }
  }
`);

const CompletedDeliveries = () => {
  const {t} = useTranslation();
  const {loading, data} = useQuery<
    CompletedDeliveriesAssignmentsQuery,
    CompletedDeliveriesAssignmentsQueryVariables
  >(AssignmentsQuery, {
    variables: {
      eventAtRange: {
        starting: addDays(startOfToday(), -30).toISOString(),
        ending: startOfToday().toISOString(),
      },
      state: DriverAssignmentState.Completed,
    },
  });

  const title = t('completedDeliveries.title');
  const header = t('completedDeliveries.header');
  const tableTitle = t('completedDeliveries.tableTitle');
  const assignments = data?.me?.driverAccount?.assignments.nodes;

  return (
    <Layout title={title}>
      <EzPage>
        <EzHeading size={'1'}>{header}</EzHeading>
        <DeliveryCardContainer assignments={assignments} loading={loading} header={tableTitle} />
      </EzPage>
    </Layout>
  );
};

export default CompletedDeliveries;
